import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './get-fare-conditions.actions';
import { GetFareConditionsState } from './get-fare-conditions.state';

/**
 * getFareConditions initial state
 */
export const getFareConditionsInitialState: GetFareConditionsState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for GetFareConditions Store
 */
export const getFareConditionsReducerFeatures: ReducerTypes<GetFareConditionsState, ActionCreator[]>[] = [
  on(actions.setGetFareConditions, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateGetFareConditions, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetGetFareConditions, () => getFareConditionsInitialState),

  on(actions.cancelGetFareConditionsRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failGetFareConditions, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setGetFareConditionsFromApi, actions.updateGetFareConditionsFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * GetFareConditions Store reducer
 */
export const getFareConditionsReducer = createReducer(
  getFareConditionsInitialState,
  ...getFareConditionsReducerFeatures
);
